module.exports = "/assets/1b9b53f9b99203e86a2c56910d22bc8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AV.png
// module id = 2338
// module chunks = 0